module.exports = __webpack_public_path__ + "static/media/circular-progress-loading.2ff4800b.mp3";